import script from "./ThresholdsSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ThresholdsSettings.vue?vue&type=script&setup=true&lang=js"

import "./ThresholdsSettings.vue?vue&type=style&index=0&id=3ca88a52&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ca88a52"]])

export default __exports__